import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  rootMenu: {
    backgroundColor: 'transparent',
    '& .menuList': {
      paddingLeft: '40px',
      paddingRight: '20px',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },
    '& .Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
      '& .menuList': {
        paddingLeft: '12px',
        color: Theme.palette.primary.light,
      },
      '& svg': {
        color: Theme.palette.primary.light,
        marginLeft: '20px',
      },
    },
    '& .MuiMenu-list': {
      padding: '0',
      paddingLeft: '0',
      '& .MuiListItem-root': {
        height: '50px',
        padding: '0',
        '&:not(.Mui-selected)': {
          '& .menuList': {
            marginLeft: '16px',
          },
        },
      },
    },
    '& .MuiPaper-root': {
      minWidth: '260px',
      boxShadow: '0px 2px 8px 2px rgb(6 21 86 / 40%) !important',
    },
  },
  label: {
    color: Theme.palette.primary.light,
    fontFamily: Theme.typography.base.regular,
    textTransform: 'capitalize',
    fontSize: Theme.typography.size[2],
    marginTop: Theme.typography.pxToRem(2),
  },
}));

export default useStyles;
